export function getCurrentLocale() {
  return document.querySelector('html').lang || 'en'
}
